import React from "react";
type SectionHeadingProps = {
  title: string;
  accent?: string;
  intro?: string;
  id?: string;
  align?: "center" | "left";
};
export function SectionHeading({
  title,
  accent,
  intro,
  id,
  align = "center"
}: SectionHeadingProps) {
  const centered = align === "center";
  return <div className={centered ? "text-center" : ""} data-id="element-239" data-mp="3jzx35wk0w2nt">
      <h2 id={id} className="font-heading text-2xl font-bold uppercase leading-tight md:text-3xl" data-id="element-240" data-mp="3k0oxl41vvuci">
        {title}
        {accent && <>
            <br data-id="element-241" data-mp="gjzqngye2imb" />
            <span className="text-brand" data-id="element-242" data-mp="giew3rc2qzog">{accent}</span>
          </>}
      </h2>
      {intro && <p className={`mt-4 max-w-3xl text-sm leading-relaxed text-ink-muted md:text-base ${centered ? "mx-auto" : ""}`} data-id="element-243" data-mp="1tsj3w9x6k0e">{intro}</p>}
    </div>;
}